var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext, useMemo } from "react";
import { CustomizationsContext } from "./customizations-provider";
//===
// Hook to get quick access to the customizations in the context
export function useCustomizations() {
    var context = useContext(CustomizationsContext);
    var customizations = useMemo(function () {
        var _a;
        return (__assign(__assign({}, context.customizations), { isInitialized: context.isInitialized, layoutVersion: (_a = context.customizations.layoutVersion) !== null && _a !== void 0 ? _a : "1.0.0", version: context.version, environment: context.environment, client: context.client, subdomain: context.subdomain, isIframe: context.isIframe, blobPaths: context.blobPaths, setCampaignName: context.setCampaignName, blobUrl: context.blobUrl, blobRootUrl: context.blobRootUrl, blobSubdomainUrl: context.blobSubdomainUrl, fetchFileAsJson: context.fetchFileAsJson, fetchCampaignFileAsJson: context.fetchCampaignFileAsJson }));
    }, [context]);
    return customizations;
}
